import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Toolbar from 'components/common/Toolbar';
import ToolbarFooter from 'components/common/Toolbar/ToolbarFooter';
import getUsers from 'redux/actions/user/getUsers';
import formatNumber from 'helpers/formatNumber';
import IndividualWalletTable from 'components/Wallet/IndividualWalletTable';
import SingleIndividualWallet from './SingleIndividualWallet';
import './index.scss';

const IndividualWallet = ({ props }) => {
  const dispatch = useDispatch();
  const { match } = props || {};
  const userId = match?.params?.groupId;

  const { items: users, meta, loading, error } = useSelector(
    ({ user: { usersList } }) => usersList,
  );

  useEffect(() => {
    getUsers(null, null, null, true)(dispatch);
  }, []);

  const onQuery = queries => {
    getUsers(null, null, queries, true)(dispatch);
  };

  if (userId) {
    return <SingleIndividualWallet match={match} />;
  }

  return (
    <div className="individual-wallet">
      <Toolbar
        header={{
          title: `All Individual Wallets (${formatNumber(
            meta?.total || 0,
          )})`,
          rightComponent: (
            <ToolbarFooter
              onSearch={onQuery}
              onPaginate={onQuery}
              paginationMeta={meta}
              exportCSVData={users}
              exportCSVFileName="IndividualWallets"
              filterTransactions
              onFilterTransactions={onQuery}
              filterTransactionsOptions={['active', 'inactive']}
            />
          ),
        }}
      />

      <div className="scroll-wrapper">
        <IndividualWalletTable
          users={users || []}
          loading={loading}
          error={error}
        />
      </div>
    </div>
  );
};

IndividualWallet.propTypes = {
  props: PropTypes.shape({
    match: PropTypes.shape({
      params: PropTypes.shape({
        groupId: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default IndividualWallet;
